angular.module("ainapp")
    .controller("AccountUploadController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService",
            function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService) {


            $scope.PageName = "Account Upload";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }


            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }


            $scope.Init = function () {

                $scope.AccountGroups = [];
                MainService.AccGroupsInDropdown().then(function (response) {
                    if (response.data != null) {
                        $scope.AccountGroups = response.data;
                    } else {
                        toastr.warning("Failed");
                    }
                    $.LoadingOverlay("hide");
                }, function (err) {
                    toastr.error("Network Error");
                    $.LoadingOverlay("hide");
                })

                $scope.Products = [];
                $scope.filter = {
                    ParentId: ""
                }
            }
            $scope.Init();


            var oFileIn;

            $(function () {
                oFileIn = document.getElementById('my_file_input');
                if (oFileIn.addEventListener) {
                    oFileIn.addEventListener('change', filePicked, false);
                }
            });

            function filePicked(oEvent) {
                var oFile = oEvent.target.files[0];
                var sFilename = oFile.name;
                var reader = new FileReader();

                reader.onload = function (e) {
                    var data = e.target.result;
                    var cfb = XLSX.read(data, {
                        type: 'binary'
                    });
                    console.log(cfb)
                    cfb.SheetNames.forEach(function (sheetName) {
                        var sCSV = XLS.utils.make_csv(cfb.Sheets[sheetName]);
                        var oJS = XLS.utils.sheet_to_json(cfb.Sheets[sheetName]);
                        //.replace(/-/g, "/");
                        angular.forEach(oJS, function (e) {
                            e.Name = e.Name;
                            e.NameAr = e.NameAr;
                            e.MobileNo = e.MobileNo;
                            e.Email = e.Email;
                            e.Address = e.Address;
                            e.Address2 = e.Address2;
                            e.Address3 = e.Address3;
                            e.TRNNo = e.TRNNo;
                            e.Description = e.Description;
                            e.Type = $scope.ProductType;
                            e.AccountCode = e.AccountCode;
                            e.ParentName = e.ParentName;
                        });

                        $scope.Products = oJS;
                        $scope.$apply();
                    });
                };

                reader.readAsBinaryString(oFile);
            }


            $scope.uploadProducts = function () {

                var temp = 0;
                angular.forEach($scope.Products, function (e) {
                    if (e.Name == null || e.Name == "" || e.Name == undefined) {
                        temp = 1;
                        toastr.warning("Invalid Format, Name needed in all rows. ");
                    } else {

                        $.LoadingOverlay("show", {
                            image: "images/load.gif",
                        });

                        var temp = [];
                        e.ParentId = $scope.filter.ParentId;
                        temp.push(e);

                        MainService.AddBulkCustomer(temp).then(function (response) {
                            if (response.data == 1) {
                                toastr.success("Success");

                                var index = $scope.Products.indexOf(e);
                                $scope.Products.splice(index, 1);

                            } else {
                                toastr.warning("Failed " + e.CustomerName);
                            }
                            $.LoadingOverlay("hide");
                        }, function (err) {
                            toastr.error("Network Error" + e.CustomerName);
                            $.LoadingOverlay("hide");
                        })
                    }
                })


            }



        }])
